import { Trait } from '../../trait.type';
import { ModifierPriority, StatusEffect } from '../../modifier.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { addModifier } from '../../player.type';

export class KnightTrait extends Trait {
  static baseType = TraitType.Knight;
  static baseTitle = "Knight's Armour";
  static baseText = 'Retain up to 5 block at the start of your turn.';
  static baseIcon = 'trait';

  type = KnightTrait.baseType;
  title = KnightTrait.baseTitle;
  text = KnightTrait.baseText;
  icon = KnightTrait.baseIcon;

  init(): void {
    this.priority = ModifierPriority.First;
  }

  beforeStartTurn(): void {
    const block = this.owner.statusEffects.find(
      (modifier: any) => modifier.type === StatusEffect.Block,
    );
    if (block) {
      this.stacks = Math.max(0, Math.min(block.stacks, 5));
    }
  }
  startTurn(): void {
    addModifier(this.owner, StatusEffect.Block, this.stacks);
    this.stacks = 0;
  }
}

TraitRegistry.register(KnightTrait.baseType, KnightTrait);
